import scssConstants from './variables.module.scss';

export const styleConstants = {
    legendHeight: parseInt(scssConstants.legendHeight),
    legendContainerMargin: parseInt(scssConstants.legendContainerMargin),
    paddingVertical: parseInt(scssConstants.paddingVertical),
    panelHeaderHeight: parseInt(scssConstants.panelHeaderHeight),
    performanceChartMinHeight: parseInt(
        scssConstants.performanceChartMinHeight
    ),
    companionChartCollapsedHeight: parseInt(
        scssConstants.companionChartCollapsedHeight
    ),
    companionChartHeightPercentage: parseInt(
        scssConstants.companionChartHeightPercentage
    ),
    spaceRound: parseInt(scssConstants.spaceAround),

    minWidth: parseInt(scssConstants.minWidth),
};
